import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, FileSearch, Calculator, FileSignature, CalendarDays } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-gold" data-id="element-154" />,
    title: '"Property Tax Slayer" Digital Guide',
    desc: 'The step-by-step roadmap to navigating the US bureaucratic system.'
  }, {
    icon: <FileSearch className="w-8 h-8 text-gold" data-id="element-155" />,
    title: 'The Secret Record Protocol',
    desc: "How to obtain and correct the errors on your home's 'resume' (Property Record Card)."
  }, {
    icon: <Calculator className="w-8 h-8 text-gold" data-id="element-156" />,
    title: 'Real Value Calculator',
    desc: 'To know exactly how much you should actually be paying.'
  }, {
    icon: <FileSignature className="w-8 h-8 text-gold" data-id="element-157" />,
    title: '"The Golden Writ" Appeal Letter Template',
    desc: 'Just fill in the blanks, print, and mail.'
  }, {
    icon: <CalendarDays className="w-8 h-8 text-gold" data-id="element-158" />,
    title: 'Critical Dates Calendar',
    desc: 'So you never lose your right to claim due to a one-day delay.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="bg-navy text-white py-20 px-4 md:px-8 relative overflow-hidden" data-id="element-159">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gold/5 blur-[150px] pointer-events-none" data-id="element-160"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-162">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-163">
            What You Get Today
          </h2>
          <p className="text-xl text-gray-300" data-id="element-164">
            Everything you need to successfully appeal your property taxes.
          </p>
        </motion.div>

        <motion.div className="space-y-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-165">
          {items.map((item, i) => <motion.div key={i} variants={itemVariants} className="bg-white/5 border border-white/10 rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6 hover:bg-white/10 transition-colors duration-300" data-id="element-166">
              <div className="bg-navy border border-gold/30 p-4 rounded-lg flex-shrink-0 shadow-gold-glow" data-id="element-167">
                {item.icon}
              </div>
              <div data-id="element-168">
                <h3 className="text-2xl font-bold text-gold mb-2" data-id="element-169">
                  {item.title}
                </h3>
                <p className="text-lg text-gray-300" data-id="element-170">{item.desc}</p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}